import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import styles from "../styles/Header.module.css";
import logo from "../assets/logo.png";

const Header = () => {
  return (
    <header className={styles.header}>
      <div className={styles.header_inner}>
        {/* Left: 로고 */}
        <div className={styles.logo}>
          <Link to="/"><img src={logo} alt='MetaAI로고' /></Link>
        </div>

        {/* Center: 카테고리 */}
        <nav className={styles.nav}>
          {/* MetaAI */}
          <div className={styles.menuItem}>
            <NavLink to="/metaai">MetaAI</NavLink>
            <div className={styles.dropdown}>
              <NavLink to="/metaai/about">회사소개</NavLink>
              <NavLink to="/metaai/history">연혁</NavLink>
              <NavLink to="/metaai/location">위치</NavLink>
            </div>
          </div>

          {/* Business (2단 서브 안에 또 하위) */}
          <div className={styles.menuItem}>
            <NavLink to="/business">Business</NavLink>

            <div className={styles.dropdown}>
              {/* AI 그룹 */}
              <div className={styles.group}>
                <span className={styles.groupTitle}>AI</span>
                <div className={styles.submenu}>
                  <NavLink to="/business/ai/product">제품소개</NavLink>
                  <NavLink to="/business/ai/research">연구개발</NavLink>
                  <NavLink to="/business/ai/education">교육</NavLink>
                  <NavLink to="/business/ai/papers">논문 및 특허</NavLink>
                </div>
              </div>
              {/* Security 그룹 */}
              <div className={styles.group}>
                <span className={styles.groupTitle}>Security</span>
                <div className={styles.submenu}>
                  <NavLink to="/business/security/product">제품소개</NavLink>
                  <NavLink to="/business/security/research">연구개발</NavLink>
                </div>
              </div>
            </div>
          </div>

          {/* Customer */}
          <div className={styles.menuItem}>
            <NavLink to="/customer">Customer</NavLink>
            <div className={styles.dropdown}>
              <NavLink to="/customer/list">고객사</NavLink>
              <NavLink to="/customer/partner">비즈니스 협력</NavLink>
            </div>
          </div>

          {/* Service Demo */}
          <div className={styles.menuItem}>
            <NavLink to="/service">Service Demo</NavLink>
            <div className={styles.dropdown}>
              <NavLink to="/service/documan">AI.DocuMan</NavLink>
            </div>
          </div>
          
        </nav>
      </div>
    </header>
  )
}

export default Header